// Stub content for placeholder pages

export const defaultEventsContent = `# Default Events

Lightswitch automatically tracks common user events for analytics.

**TODO**: Document default event schemas and configuration options.`;

export const dashboardsExportContent = `# Dashboards & Export

View analytics dashboards and export data for external analysis.

**TODO**: Add dashboard screenshots and export format documentation.`;

export const adminBasicsContent = `# Admin Basics

Basic administration and management of your Lightswitch instance.

**TODO**: Document admin panel features and common tasks.`;

export const testModeContent = `# Test Mode

Use test mode for development and staging environments.

**TODO**: Explain test mode configuration and limitations.`;

export const supabaseIntegrationContent = `# Supabase Integration Details

Deep dive into Supabase integration patterns and best practices.

**TODO**: Add advanced Supabase configuration and optimization tips.`;

export const multiTenantSetupContent = `# Multi-Tenant Setup (SaaS)

Configure Lightswitch for multi-tenant SaaS applications.

**TODO**: Document tenant isolation and management strategies.`;

export const migratingContent = `# Migrating from Clerk/RevenueCat

Migration guide from other authentication and billing providers.

**TODO**: Add step-by-step migration instructions and code examples.`;

export const restApiContent = `# REST API

Complete REST API reference for server-side integration.

**TODO**: Document all endpoints with request/response examples.`;

export const sdkReferenceContent = `# SDK Reference (JS/Python)

Complete SDK method reference for JavaScript and Python.

**TODO**: Add comprehensive method documentation with examples.`;

export const eventSchemasContent = `# Event Schemas

Schema definitions for all Lightswitch events and webhooks.

**TODO**: Document event structures and validation rules.`;

export const faqContent = `# FAQ

Frequently asked questions and troubleshooting guide.

**TODO**: Compile common questions and detailed answers.`;
